import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SystemTaskDataModel} from '../models/messaging/system-task-data.model';
import {TdoUserConfigurationModel} from '../models/configuration/user/tdo-user-configuration.model';
import {TaskQueryModel} from '../dialog/tasks/task-management-dialog/task-management-dialog.component';
import { Observable } from 'rxjs';
import {dataPatientCaseWorkItemEventModel} from "../models/Events/dataPatientCaseWorkItemEvent.model";


@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(private http: HttpClient) {

  }

  getUser(userId: string) {
    return this.http.get<TdoUserConfigurationModel>(`api/task/get-user/${userId}`);
  }

  getTasks(queryModel: TaskQueryModel) {
    return this.http.post<SystemTaskDataModel[]>('api/task/get-tasks', queryModel);
  }

  getTasksForUser(userId: string) : Observable<SystemTaskDataModel[]> {
    return this.http.get<SystemTaskDataModel[]>(`api/task/get-tasks-for-user/${userId}`);
  }

  getAllTasks() : Observable<SystemTaskDataModel[]> {
    return this.http.get<SystemTaskDataModel[]>(`api/task/get-all-tasks`);
  }

  saveTask(task: SystemTaskDataModel) {
    return this.http.post<SystemTaskDataModel>('api/task/save-task', task);
  }

  setNotesToFrontCallTask(callInfo: any) {
    return this.http.post(`api/task/post-note-to-front-task`, callInfo);
  }

  createTaskEvent(taskEvent: dataPatientCaseWorkItemEventModel) {
    return this.http.post<dataPatientCaseWorkItemEventModel>('api/task/create-taskEvent', taskEvent);
  }

  updateTask(task: SystemTaskDataModel) {
    return this.http.post<SystemTaskDataModel>('api/task/update-task', task);
  }

}
